// eslint-disable-next-line import/prefer-default-export
export const GetAllUnitsByFormulaTypeAPI = 'api/UkNomination/GetAllUnits';
